(() => {
  const text = (key, fallback) => window.RenlyUI?.[key] ?? fallback;
  const storefrontCurrency = window.Shopify?.currency?.active || document.querySelector('[data-renly-root]')?.dataset.currency || 'SEK';
  const money = (cents, currency = storefrontCurrency) => {
    const country = document.querySelector('[data-renly-root]')?.dataset.country || window.Shopify?.country;
    const locale = { SE: 'sv-SE', NO: 'nb-NO', DK: 'da-DK', DE: 'de-DE', CH: 'de-CH' }[country]
      || document.documentElement.lang || 'sv-SE';
    const fractionDigits = Number(cents) % 100 === 0 ? 0 : 2;
    const amount = new Intl.NumberFormat(locale, {
      minimumFractionDigits: fractionDigits, maximumFractionDigits: 2,
    }).format(cents / 100);
    // Match native Shopify price cards, including a non-breaking currency space.
    const symbol = { SEK: 'kr', NOK: 'kr', DKK: 'kr', EUR: '€', CHF: 'CHF' }[currency];
    if (symbol) return currency === 'CHF' ? `${symbol}\u00a0${amount}` : `${amount}\u00a0${symbol}`;
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  };
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const safeSession = { getItem: key => { try { return sessionStorage.getItem(key); } catch { return null; } }, setItem: (key, value) => { try { sessionStorage.setItem(key, value); } catch {} }, removeItem: key => { try { sessionStorage.removeItem(key); } catch {} } };
  const cartEndpoint = (name) => name ? `${rootPath()}cart/${name}.js` : `${rootPath()}cart.js`;

  const seasonalOffer = (date = new Date()) => {
    const month = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Stockholm', month: 'numeric' }).format(date));
    const season = [text('winter', 'VINTERREA'), text('spring', 'VÅRREA'), text('summer', 'SOMMARREA'), text('autumn', 'HÖSTREA')][Math.floor((month % 12) / 3)];
    return `${season}: ${(window.FTBOffer?.arm === 'test' ? text('buy_two_one', 'KÖP 2, FÅ 1 GRATIS') : text('buy_two', 'KÖP 2, FÅ 2 GRATIS'))}`;
  };

  function init(root) {
    if (root.dataset.renlyInitialized === 'true') return;
    root.dataset.renlyInitialized = 'true';
    const updateSeasonalOffer = () => root.querySelectorAll('[data-seasonal-offer]').forEach(node => {
      node.textContent = seasonalOffer();
    });
    updateSeasonalOffer();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && root.isConnected) updateSeasonalOffer();
    });
    const cartLayer = root.querySelector('[data-cart]');
    const cartItems = root.querySelector('[data-cart-items]');
    const errorNode = root.querySelector('[data-cart-error]');
    const drawerErrorNode = root.querySelector('[data-cart-drawer-error]');
    const checkoutLink = root.querySelector('[data-checkout]');
    const cartStatus = document.createElement('p');
    cartStatus.className = 'renly-cart__status'; cartStatus.setAttribute('role', 'status'); cartStatus.hidden = true;
    cartLayer.querySelector('.renly-cart__footer').prepend(cartStatus);
    const allOffers = [...root.querySelectorAll('[data-offer]')];
    const offerArm = window.FTBOffer?.arm || 'control';
    window.FTBOffer?.mount(root);
    const packVersion = '12';
    const offers = allOffers.filter(node => (!node.dataset.offerArm || node.dataset.offerArm === offerArm) && (node.dataset.styleValue !== 'Pro' || node.dataset.packVersion === packVersion));
    const initialPack = offerArm === 'test' ? '1' : offers.find(node => node.querySelector('input').checked)?.dataset.pack || '1';
    allOffers.filter(node => !offers.includes(node)).forEach(node => { node.hidden = true; node.querySelector('input').checked = false; });
    if (offerArm === 'test' || !offers.some(node => node.querySelector('input').checked)) {
      offers.forEach(node => { node.querySelector('input').checked = false; });
      const initialStyle = root.querySelector('[data-style]:checked')?.value || 'Pro';
      const first = offers.find(node => node.dataset.styleValue === initialStyle && node.dataset.pack === initialPack) || offers.find(node => node.dataset.styleValue === initialStyle) || offers[0];
      first.querySelector('input').checked = true;
    }
    const styleInputs = [...root.querySelectorAll('[data-style]')];
    const productIds = new Set(window.RenlyCheckout ? [...window.RenlyCheckout.family.keys()] : offers.map(node => Number(node.dataset.variantId)));
    const giftVariantId = Number(root.dataset.giftVariant || 0);
    const giftVariantPrice = Number(root.dataset.giftPrice || 0);
    const valuedGiftVariantId = Number(root.dataset.valuedGiftVariant || 0);
    const giftForAdd = cart => valuedGiftVariantId && Number(root.dataset.valuedGiftPrice) > 0 && root.dataset.valuedGiftAvailable === 'true' ? valuedGiftVariantId : giftVariantId;
    const valuedGiftLine = item => valuedGiftVariantId && Number(item.variant_id) === valuedGiftVariantId;
    const confirmedGiftValue = item => {
      const original = Number(item.original_line_price);
      const discount = Math.max(Number(item.total_discount) || 0, Number(item.line_level_total_discount) || 0,
        (item.line_level_discount_allocations || item.discount_allocations || []).reduce((sum,x)=>sum+Number(x.amount || 0),0));
      return valuedGiftLine(item) && item.quantity === 1 && item.final_line_price === 0 && original > 0 && discount >= original ? original : 0;
    };
    // Project the promised gift presentation only for our local pending gift line.
    // Native discounts remain authoritative once the server response settles.
    const pendingGiftValue = item => valuedGiftLine(item) && item.key === 'pending-gift' && item.quantity === 1
      && Number(item._renly_pending_gift_value) > 0 ? Number(item._renly_pending_gift_value) : 0;
    const displayGiftValue = (item, optimistic) => confirmedGiftValue(item) || (optimistic ? pendingGiftValue(item) : 0);
    let cartCurrency = root.dataset.currency || storefrontCurrency;
    let cartEmpty = true;
    let busy = false;
    let pendingAdd = false;
    let pendingCartTransform = null;
    let checkoutQueued = false;
    let quantityQueueRunning = false;
    const quantityTargets = new Map();
    const checkoutLabel = checkoutLink?.textContent;
    let confirmedCart = window.RenlyCheckout?.catalog.cart || null;
    let confirmedAt = 0;
    let cartRead = null;
    let cartRevision = 0;
    const cartStateSection = 'renly-cart-state';
    window.addEventListener('focus', () => { confirmedAt = 0; });
    document.addEventListener('visibilitychange', () => { if (document.hidden) confirmedAt = 0; });
    const reservationKey = 'renly-cart-reservation-deadline';
    const reservationNode = root.querySelector('[data-cart-reservation]');
    const reservationTime = root.querySelector('[data-reservation-time]');
    let reservationInterval = null;
    let priorFocus = null;
    const priorInert = new Map();

    function updateCheckout() {
      const disabled = checkoutQueued || (cartEmpty && !pendingAdd);
      checkoutLink?.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      checkoutLink?.setAttribute('aria-busy', busy || checkoutQueued ? 'true' : 'false');
      if (checkoutLink) {
        checkoutLink.tabIndex = disabled ? -1 : 0;
        checkoutLink.textContent = checkoutQueued ? text('checkout_pending', 'GÅR TILL KASSAN…') : checkoutLabel;
      }
    }
    function requestCheckout(event) {
      if (checkoutQueued) { event.preventDefault(); return; }
      if (busy) {
        event.preventDefault();
        checkoutQueued = true;
        updateCheckout();
        return;
      }
      event.preventDefault();
      if(!cartEmpty){checkoutQueued=true;updateCheckout();void goCheckout();}
    }
    async function goCheckout(){
      try {
        if (window.RenlyCheckout) renderCart(await window.RenlyCheckout.normalize());
        window.location.assign(checkoutLink.getAttribute('href') || `${rootPath()}checkout`);
      } catch(error) {checkoutQueued=false;updateCheckout();drawerErrorNode.textContent=error.message;drawerErrorNode.hidden=false;}
    }
    function finishQueuedCheckout(succeeded) {
      if (!checkoutQueued) return;
      if (succeeded && !cartEmpty) {
        void goCheckout();
        return;
      }
      checkoutQueued = false;
      updateCheckout();
    }
    function setBusy(next) {
      busy = next;
      if (next) cartRevision++;
      cartItems.toggleAttribute('data-cart-pending', next);
      cartStatus.hidden = !next;
      cartStatus.textContent = next ? text('confirming', 'Bekräftar…') : '';
      styleInputs.forEach(input => { input.disabled = next; });
      offers.forEach(node => { node.querySelector('input').disabled = next; });
      updateCheckout();
      cartItems.querySelectorAll('button').forEach(button => { button.disabled = next && (!quantityQueueRunning || !button.hasAttribute('data-quantity-key')); });
      cartLayer.querySelector('.renly-cart__panel')?.setAttribute('aria-busy', next ? 'true' : 'false');
      if (next) root.querySelectorAll('[data-add-to-cart]').forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = text('adding', 'Lägger till i varukorgen…'); });
      else { root.querySelectorAll('[data-add-to-cart]').forEach(button => button.removeAttribute('aria-busy')); setOffer(selectedOffer()); }
    }
    checkoutLink?.addEventListener('click', requestCheckout);

    function selectedOffer() {
      return offers.find(node => node.querySelector('input').checked) || offers[0];
    }
    function setOffer(node) {
      if (!node || busy) return;
      node.querySelector('input').checked = true;
      document.documentElement.classList.toggle('renly-ultra-selected', node.dataset.styleValue === 'Ultra');
      if (styleInputs.length) {
        offers.forEach(offer => { offer.hidden = offer.dataset.styleValue !== node.dataset.styleValue; });
        styleInputs.forEach(input => { input.checked = input.value === node.dataset.styleValue; });
        root.querySelector('[data-product-style]').textContent = node.dataset.styleValue;
        document.title = `Renly ${node.dataset.styleValue}: ${text('descriptor', 'Tvättmaskinsrengöring')}`;
        root.querySelector('[data-detail-style]').textContent = node.dataset.styleValue;
        root.querySelector('[data-ultra-detail]').hidden = node.dataset.styleValue !== 'Ultra';
      }
      if (window.FTBStore?.storeId === 'renly') window.FTBStore.variantId = Number(node.dataset.variantId);
      offers.forEach(offer => offer.classList.toggle('is-selected', offer === node));
      const available = node.dataset.available === 'true';
      const stock = root.querySelector('[data-stock-status]');
      const stockLabel = root.querySelector('[data-stock-label]');
      const purchaseButton = root.querySelector('[data-add-to-cart]');
      if (stock) stock.classList.toggle('is-sold-out', !available);
      if (stockLabel) stockLabel.textContent = available ? text('in_stock', 'I lager') : text('sold_out', 'Tillfälligt slut');
      if (purchaseButton) {
        purchaseButton.disabled = !available || busy;
        purchaseButton.textContent = available ? text('add_cart', 'LÄGG I VARUKORGEN') : text('sold_out_upper', 'TILLFÄLLIGT SLUT');
      }
      const price = Number(node.dataset.price || 0);
      const comparePrice = Number(node.dataset.comparePrice || 0);
      const stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(price, cartCurrency);
      const currentPrice = root.querySelector('[data-current-price]');
      if (currentPrice) currentPrice.textContent = money(price, cartCurrency);
      const oldPrice = root.querySelector('[data-compare-price]');
      if (oldPrice) {
        oldPrice.hidden = comparePrice <= price;
        oldPrice.textContent = comparePrice > price ? money(comparePrice, cartCurrency) : '';
      }
    }
    offers.forEach(node => node.querySelector('input').addEventListener('change', () => setOffer(node)));
    const mobileMenu = root.querySelector('.renly-mobile-menu');
    mobileMenu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { mobileMenu.open = false; }));
    mobileMenu?.addEventListener('toggle', () => {
      const trigger = mobileMenu.querySelector('summary');
      if (trigger) trigger.setAttribute('aria-label', mobileMenu.open ? text('menu_close', 'Stäng menyn') : text('menu_open', 'Öppna menyn'));
    });

    const { slides, gallery, reducedMotion, centerThumbnail } = window.RenlyGallery.initialize(root.querySelector('[data-gallery]'));
    function showStyleMedia(node) {
      const mediaIndex = slides.findIndex(slide => slide.dataset.mediaId === node.dataset.mediaId);
      const fallback = slides.findIndex(slide => (slide.dataset.mediaAlt || '').toLowerCase().includes(`renly ${node.dataset.styleValue.toLowerCase()}`));
      const index = mediaIndex >= 0 ? mediaIndex : fallback;
      if (index >= 0) { gallery?.slideToLoop(index, reducedMotion() ? 0 : 480); centerThumbnail(index); }
    }
    styleInputs.forEach(input => input.addEventListener('change', () => {
      if (busy) return;
      const pack = selectedOffer()?.dataset.pack;
      const choices = offers.filter(offer => offer.dataset.styleValue === input.value);
      const next = choices.find(offer => offer.dataset.pack === pack) || choices[0];
      setOffer(next);
      showStyleMedia(next);
    }));
    if (styleInputs.length) { setOffer(selectedOffer()); showStyleMedia(selectedOffer()); }
    const comparisonDialog = root.querySelector('[data-comparison-dialog]');
    let comparisonTrigger = null;
    let previousOverflow = '';
    root.querySelectorAll('[data-comparison-open]').forEach(button => button.addEventListener('click', () => {
      comparisonTrigger = button;
      previousOverflow = document.documentElement.style.overflow;
      comparisonDialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }));
    root.querySelector('[data-comparison-close]')?.addEventListener('click', () => comparisonDialog.close());
    comparisonDialog?.addEventListener('click', event => {
      const bounds = comparisonDialog.getBoundingClientRect();
      if (event.target === comparisonDialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) comparisonDialog.close();
    });
    comparisonDialog?.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      comparisonTrigger?.focus();
    });

    root.querySelectorAll('.renly-faq details, .renly-accordion').forEach(details => {
      const summary = details.querySelector('summary');
      let wantedOpen = details.open;
      let animation;
      summary?.addEventListener('click', event => {
        event.preventDefault();
        wantedOpen = !wantedOpen;
        const startHeight = details.getBoundingClientRect().height;
        animation?.cancel();
        if (wantedOpen) details.open = true;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          details.open = wantedOpen;
          return;
        }
        const answer = details.querySelector(':scope > p, :scope > div');
        const endHeight = summary.getBoundingClientRect().height + (wantedOpen ? answer?.getBoundingClientRect().height || 0 : 0) + 2;
        details.style.overflow = 'hidden';
        animation = details.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, { duration: 220, easing: 'ease-out' });
        const thisAnimation = animation;
        animation.onfinish = () => {
          if (animation !== thisAnimation) return;
          details.open = wantedOpen;
          details.style.overflow = '';
          animation = null;
        };
      });
    });

    function openCart({ refresh = true } = {}) {
      if (confirmedCart && !busy) renderCart(confirmedCart);
      priorFocus = document.activeElement;
      drawerErrorNode.hidden = true;
      cartLayer.classList.add('is-open');
      cartLayer.setAttribute('aria-hidden', 'false');
      [...root.children].filter(child => child !== cartLayer).forEach(child => {
        priorInert.set(child, child.inert);
        child.inert = true;
      });
      document.body.style.overflow = 'hidden';
      updateSticky();
      cartLayer.querySelector('.renly-cart__header button')?.focus();
      if (refresh && !busy) refreshCart();
    }
    function closeCart() {
      cartLayer.classList.remove('is-open');
      cartLayer.setAttribute('aria-hidden', 'true');
      priorInert.forEach((wasInert, child) => { child.inert = wasInert; });
      priorInert.clear();
      document.body.style.overflow = '';
      updateSticky();
      priorFocus?.focus?.();
    }
    root.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
    root.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', closeCart));
    document.addEventListener('keydown', event => {
      if (!cartLayer.classList.contains('is-open')) return;
      if (event.key === 'Escape') { closeCart(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...cartLayer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')].filter(node => node.tabIndex >= 0 && node.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !cartLayer.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !cartLayer.contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });

    async function requestCart(url, options) {
      const response = await fetch(url, { credentials: 'same-origin', ...options });
      if (!response.ok) {
        let message = text('cart_update_error', 'Varukorgen kunde inte uppdateras. Försök igen.');
        try { const body = await response.json(); message = body.description || body.message || message; } catch (_) {}
        const error = new Error(message);
        error.status = response.status;
        throw error;
      }
      return response.json();
    }
    function giftLine(item) { return window.RenlyCheckout?.isGift(item) || item.properties?._renly_gift === 'true'; }
    function updateReservation(hasItems = !cartEmpty) {
      if (!reservationNode || !reservationTime) return;
      if (!hasItems) safeSession.removeItem(reservationKey);
      const deadline = Number(safeSession.getItem(reservationKey) || 0);
      const remaining = Math.max(0, deadline - Date.now());
      reservationNode.hidden = !hasItems || !remaining;
      if (remaining) {
        const seconds = Math.ceil(remaining / 1000);
        reservationTime.textContent = `${Math.floor(seconds / 60)}m ${String(seconds % 60).padStart(2, '0')}s`;
        if (!reservationInterval) reservationInterval = window.setInterval(() => updateReservation(), 1000);
      } else if (reservationInterval) {
        window.clearInterval(reservationInterval);
        reservationInterval = null;
        if (deadline) safeSession.removeItem(reservationKey);
      }
    }
    function startReservation() {
      if (!safeSession.getItem(reservationKey)) safeSession.setItem(reservationKey, String(Date.now() + 60 * 60 * 1000));
      cartEmpty = false;
      updateReservation(true);
    }
    // Compare bundle contents with the same formula's current single-pack offer.
    function cartLineOffer(item, currency = root.dataset.currency) {
      const receiptArm = ['renly-all-offer-v1', 'renly-all-offer-v2'].includes(item.properties?._ftb_experiment) ? item.properties._ftb_variant : null;
      const lineArm = ['control', 'test'].includes(receiptArm) ? receiptArm : 'control';
      const lineOffers = allOffers.filter(node => !node.dataset.offerArm || node.dataset.offerArm === lineArm);
      const offer = lineOffers.find(node => Number(node.dataset.variantId) === Number(item.variant_id));
      const packs = Number(offer?.dataset.pack);
      const single = offer && lineOffers.find(node => node.dataset.styleValue === offer.dataset.styleValue
        && node.dataset.packVersion === offer.dataset.packVersion && Number(node.dataset.pack) === 1);
      const baseline = Number(single?.dataset.price);
      const reference = currency === root.dataset.currency && packs > 1 && baseline > 0 ? baseline * packs * item.quantity : 0;
      const badge = packs === 3 && lineArm === 'test' ? text('buy_two_one', 'KÖP 2, FÅ 1 GRATIS') : packs === 4 && lineArm === 'control' ? text('buy_two', 'KÖP 2, FÅ 2 GRATIS') : '';
      return {offer, reference, badge};
    }
    function bundleSavings(cart) {
      if (cart.currency && cart.currency !== root.dataset.currency) return 0;
      return cart.items.reduce((total, item) => {
        if (giftLine(item)) return total + confirmedGiftValue(item);
        if (!Number.isFinite(item.final_line_price)) return total;
        const {reference} = cartLineOffer(item, cart.currency || root.dataset.currency);
        return total + (reference > 0 ? Math.max(0, reference - item.final_line_price) : 0);
      }, 0);
    }
    function renderCart(cart, { optimistic = false } = {}) {
      if (!optimistic) {
        confirmedCart = cart;
        confirmedAt = Date.now();
        // Keep an in-flight read from replacing the intended final layout.
        if (pendingCartTransform) return renderCart(pendingCartTransform(cart), { optimistic: true });
      }
      cartItems.toggleAttribute('data-cart-pending', optimistic);
      cartCurrency = cart.currency || cartCurrency;
      cartEmpty = cart.items.length === 0;
      updateReservation(!cartEmpty);
      updateCheckout();
      root.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
      root.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price, cartCurrency);
      const pendingGifts = optimistic ? cart.items.filter(item => pendingGiftValue(item) && !confirmedGiftValue(item)) : [];
      const savings = bundleSavings(cart) + (pendingGifts.length === 1 ? pendingGiftValue(pendingGifts[0]) : 0);
      const savingsRow = root.querySelector('[data-cart-savings-row]');
      if (savingsRow) {
        savingsRow.hidden = savings <= 0;
        savingsRow.querySelector('[data-cart-savings]').textContent = `−${money(savings, cartCurrency)}`;
      }
      if (!cart.items.length) {
        cartItems.innerHTML = `<div class="renly-cart__empty"><p>${escapeHtml(text('cart_empty', 'Din varukorg är tom.'))}</p><p>${escapeHtml(text('cart_empty_help', 'Välj en förpackning för att komma igång.'))}</p></div>`;
        return;
      }
      const orderedItems = [...cart.items.filter(item => !giftLine(item)), ...cart.items.filter(giftLine)];
      cartItems.innerHTML = orderedItems.map((item, index) => {
        const gift = giftLine(item);
        const productLabel = (item.product_id === 10913724760397 || window.RenlyCheckout?.productIds.has(item.product_id)) ? text('cleaner_title', item.product_title) : item.product_id === 10928408002893 ? text('hair_title', item.product_title) : item.product_title;
        const cleaner = item.product_id === 10913724760397 || window.RenlyCheckout?.productIds.has(item.product_id);
        const formula = cleaner && item.variant_title?.match(/\b(Pro|Ultra)\b/i)?.[1];
        const displayLabel = formula ? `${productLabel} ${formula.toLowerCase() === 'ultra' ? 'Ultra' : 'Pro'}` : productLabel;
        const nativeGiftValue = displayGiftValue(item, optimistic);
        const label = gift ? (nativeGiftValue ? `${text('secret_gift', 'Hemlig gåva')} (${money(nativeGiftValue, cartCurrency)})` : text('gift_name', 'Överraskningsgåva')) : displayLabel;
        const lineOffer = cartLineOffer(item, cart.currency || root.dataset.currency);
        const matchingOffer = lineOffer.offer;
        const localizedVariant = matchingOffer ? matchingOffer.querySelector('strong').textContent.trim() : cleaner ? item.variant_title?.replace(/\s*\/\s*(Pro|Ultra)\s*$/i, '').trim() : item.variant_title;
        const detail = gift ? (item.final_line_price === 0 ? '' : text('gift', 'Gåva')) : (localizedVariant || '');
        const regular = Math.max(Number(item.original_line_price) || 0, lineOffer.reference);
        const discounted = nativeGiftValue > 0 || (!gift && item.final_line_price > 0 && regular > item.final_line_price);
        const controls = gift ? '' : `<div class="renly-cart__quantity"><button type="button" data-quantity-key="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="${escapeHtml(text('quantity_less', 'Minska antal'))} ${escapeHtml(label)}">−</button><span>${item.quantity}</span><button type="button" data-quantity-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${escapeHtml(text('quantity_more', 'Öka antal'))} ${escapeHtml(label)}">+</button></div>`;
        const giftIcon = '<svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><path d="M6 20h36v22H6zM3 15h42v7H3zM24 15v27M24 15c-5-8-14-12-14-6 0 5 6 6 14 6Zm0 0c5-8 14-12 14-6 0 5-6 6-14 6Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/></svg>';
        const imageName = item.image?.split('/').pop().split('?')[0];
        const galleryImage = matchingOffer && root.querySelector(`[data-media-id="${matchingOffer.dataset.mediaId}"] img`);
        const cartImage = (galleryImage?.complete && galleryImage.naturalWidth ? galleryImage.currentSrc || galleryImage.src : null) || window.RenlyMedia?.[imageName] || item.image;
        const art = gift ? (nativeGiftValue ? root.querySelector('.renly-mystery-gift-art')?.outerHTML || giftIcon : giftIcon) : cartImage ? `<img src="${escapeHtml(cartImage)}" alt="" loading="lazy">` : 'RENLY';
        const giftHeading = gift && (index === 0 || !giftLine(orderedItems[index - 1])) ? `<h3 class="renly-cart__gift-heading">${escapeHtml(text('your_free_gifts', 'Dina gratisgåvor'))}</h3>` : '';
        return `${giftHeading}<div class="renly-cart__line${gift ? ' renly-cart__line--gift' : giftLine(orderedItems[index + 1] || {}) ? ' renly-cart__line--before-gift' : ''}"><div class="renly-cart__line-art${gift ? ' renly-cart__line-art--gift' : ''}">${art}</div><div class="renly-cart__line-main"><strong>${escapeHtml(label)}</strong>${detail ? `<small>${escapeHtml(detail)}</small>` : ''}<div class="renly-cart__purchase-row"><div class="renly-cart__prices">${discounted ? `<del class="renly-cart__compare">${money(regular, cartCurrency)}</del>` : ''}<span class="renly-cart__line-price">${gift && item.final_line_price === 0 ? text('free_upper', 'GRATIS') : money(item.final_line_price, cartCurrency)}</span></div>${controls}</div>${nativeGiftValue ? `<span class="renly-cart__offer-badge renly-cart__offer-badge--gift">${escapeHtml(text('free_upper', 'GRATIS'))} · ${escapeHtml(text('gift_value', '%value% VÄRDE').replace('%value%',money(nativeGiftValue,cartCurrency)))}</span>` : !gift && lineOffer.badge ? `<span class="renly-cart__offer-badge">${escapeHtml(lineOffer.badge)}</span>` : ''}</div></div>`;
      }).join('');
      cartItems.querySelectorAll('button').forEach(button => { button.disabled = busy && (!quantityQueueRunning || !button.hasAttribute('data-quantity-key')); });
    }
    async function acceptCart(cart) {
      if (window.RenlyCheckout) cart = await window.RenlyCheckout.normalize(cart);
      renderCart(cart);
      return cart;
    }
    async function refreshCart() {
      if (cartRead) return cartRead;
      const revision = cartRevision;
      cartRead = (async () => {
        try {
          const value = await requestCart(cartEndpoint(''), { method: 'GET' });
          if (revision !== cartRevision) return confirmedCart;
          return await acceptCart(value);
        }
        catch (error) { confirmedAt = 0; console.error('Renly cart read failed', error); if (cartLayer.classList.contains('is-open')) { drawerErrorNode.textContent = error.message; drawerErrorNode.hidden = false; } return null; }
      })();
      try { return await cartRead; }
      finally { cartRead = null; }
    }
    async function currentCart() {
      if (cartRead) {
        const cart = await cartRead;
        if (!cart) throw new Error(text('cart_read_error', 'Varukorgen kunde inte hämtas. Försök igen.'));
        return cart;
      }
      if (confirmedCart && Date.now() - confirmedAt < 10000) return confirmedCart;
      const cart = await refreshCart();
      if (!cart) throw new Error(text('cart_read_error', 'Varukorgen kunde inte hämtas. Försök igen.'));
      return cart;
    }
    function bundledCart(response) {
      try {
        const html = response.sections?.[cartStateSection];
        if (!html) return null;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cart = JSON.parse(doc.querySelector('[data-renly-cart-state]').textContent);
        return Array.isArray(cart.items) && Number.isFinite(cart.total_price) ? cart : null;
      } catch { return null; }
    }
    function wantsGift(cart) {
      return root.dataset.giftEnabled === 'true' && giftForAdd(cart) && (giftForAdd(cart) === valuedGiftVariantId || giftVariantPrice === 0) && !cart.items.some(giftLine);
    }
    function paidLineProperties(selected) {
      const tablets = selected.dataset.packVersion || '24';
      return { ...window.FTBOffer?.tags(), ...window.FTBReassurance?.tags(), ...(window.RenlyQA ? { _ftb_qa: 'true' } : {}),
        [text('pack_contents', 'Tablets per pack')]: tablets, _renly_tablets_per_pack: tablets };
    }
    function cartWithItems(cart, items) {
      const oldLines = cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
      const newLines = items.reduce((sum, item) => sum + item.final_line_price, 0);
      return { ...cart, items, item_count: items.reduce((sum, item) => sum + item.quantity, 0), total_price: cart.total_price - oldLines + newLines };
    }
    function pendingAddCart(selected, cart) {
      const items = cart.items.map(item => ({ ...item }));
      const variantId = Number(selected.dataset.variantId);
      const price = Number(selected.dataset.price);
      const properties = paidLineProperties(selected);
      const existing = items.find(item => item.variant_id === variantId && Object.keys(item.properties || {}).length === Object.keys(properties).length && Object.entries(properties).every(([key, value]) => item.properties?.[key] === value));
      if (existing) { existing.quantity++; existing.final_line_price += price; }
      else items.unshift({ key: 'pending-paid', variant_id: variantId, product_id: Number(root.dataset.productId || 10913724760397), product_title: root.dataset.productTitle || text('cleaner_title', 'Renly Pro'), variant_title: selected.dataset.variantTitle, image: selected.dataset.cartImage, quantity: 1, final_line_price: price, properties });
      if (wantsGift(cart)) {
        const pendingGiftId = giftForAdd(cart);
        const expectedValue = pendingGiftId === valuedGiftVariantId ? Number(root.dataset.valuedGiftPrice) : 0;
        items.push({ key: 'pending-gift', variant_id: pendingGiftId, quantity: 1, original_line_price: expectedValue,
          final_line_price: 0, _renly_pending_gift_value: expectedValue, properties: { _renly_gift: 'true' } });
      }
      return cartWithItems(cart, items);
    }
    function showPendingItem(selected, cart = confirmedCart || { items: [], item_count: 0, total_price: 0, currency: cartCurrency }) {
      const predicted = pendingAddCart(selected, cart);
      startReservation();
      renderCart(predicted, { optimistic: true });
    }
    function pendingRemovalCart(key, cart) {
      let items = cart.items.filter(item => item.key !== key);
      const count = window.RenlyCheckout?.giftCount({ ...cart, items }) ?? (items.some(item => productIds.has(item.variant_id)) ? 1 : 0);
      items = count ? items.map(item => giftLine(item) ? { ...item, quantity: count } : item) : items.filter(item => !giftLine(item));
      return cartWithItems(cart, items);
    }
    async function changeLine(key, quantity) {
      return requestCart(cartEndpoint('change'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    }
    async function removeLine(key) {
      if (busy) return;
      setBusy(true);
      drawerErrorNode.hidden = true;
      const priorDeadline = safeSession.getItem(reservationKey);
      pendingCartTransform = cart => pendingRemovalCart(key, cart);
      if (confirmedCart) renderCart(pendingCartTransform(confirmedCart), { optimistic: true });
      try {
        const before = await currentCart();
        window.FTBOffer?.checkCart(before);
        window.FTBReassurance?.checkCart(before);
        if (before.items.some(item => item.key === key && giftLine(item))) return;
        confirmedAt = 0;
        let cart = await changeLine(key, 0);
        cart = await window.RenlyCheckout.normalize(cart);
        pendingCartTransform = null;
        renderCart(cart);
        if (!cart.items.length) closeCart();
      } catch (error) {
        pendingCartTransform = null;
        if (priorDeadline) safeSession.setItem(reservationKey, priorDeadline);
        if (confirmedCart) renderCart(confirmedCart);
        drawerErrorNode.textContent = error.message;
        drawerErrorNode.hidden = false;
        await refreshCart();
      }
      finally { pendingCartTransform = null; setBusy(false); }
    }
    function pendingQuantityCart(key, quantity, cart) {
      return cartWithItems(cart, cart.items.map(item => item.key !== key ? { ...item } : { ...item, quantity,
        final_line_price: Math.round(item.final_line_price / item.quantity * quantity),
        original_line_price: Math.round((item.original_line_price || item.final_line_price) / item.quantity * quantity) }));
    }
    function projectQuantities(cart) {
      for (const [key, quantity] of quantityTargets) cart = quantity <= 0 ? pendingRemovalCart(key, cart) : pendingQuantityCart(key, quantity, cart);
      return cart;
    }
    function rekeyQuantityTargets(previous, next) {
      for (const [key, quantity] of [...quantityTargets]) {
        if (next.items.some(item => item.key === key)) continue;
        const old = previous.items.find(item => item.key === key);
        const candidates = next.items.filter(item => item.variant_id === old?.variant_id && JSON.stringify(item.properties || {}) === JSON.stringify(old?.properties || {}) && item.selling_plan_allocation?.selling_plan?.id === old?.selling_plan_allocation?.selling_plan?.id);
        quantityTargets.delete(key);
        if (candidates.length === 1) quantityTargets.set(candidates[0].key, quantity);
        else if (quantity > 0) throw new Error(text('cart_update_error', 'Varukorgen kunde inte uppdateras. Försök igen.'));
      }
    }
    async function updateQuantity(key, quantity) {
      if (busy && !quantityQueueRunning) return;
      const item = confirmedCart?.items.find(item => item.key === key);
      if (!item || giftLine(item)) return;
      quantityTargets.set(key, Math.max(0, quantity));
      pendingCartTransform = projectQuantities;
      if (quantityQueueRunning) { renderCart(projectQuantities(confirmedCart), { optimistic: true }); return; }
      quantityQueueRunning = true;
      setBusy(true);
      drawerErrorNode.hidden = true;
      renderCart(projectQuantities(confirmedCart), { optimistic: true });
      let succeeded = false;
      let removedPaidLine = false;
      try {
        await currentCart();
        while (quantityTargets.size) {
          const [lineKey, target] = quantityTargets.entries().next().value;
          const current = confirmedCart.items.find(item => item.key === lineKey);
          if (!current || current.quantity === target) { quantityTargets.delete(lineKey); continue; }
          const cart = await window.RenlyCheckout.normalize(await changeLine(lineKey, target));
          if (target === 0) removedPaidLine = true;
          if (quantityTargets.get(lineKey) === target) quantityTargets.delete(lineKey);
          rekeyQuantityTargets(confirmedCart, cart);
          renderCart(cart);
        }
        pendingCartTransform = null;
        renderCart(confirmedCart);
        succeeded = true;
      } catch (error) {
        quantityTargets.clear(); pendingCartTransform = null; checkoutQueued = false;
        if (confirmedCart) renderCart(confirmedCart);
        drawerErrorNode.textContent = error.message;
        drawerErrorNode.hidden = false;
        await refreshCart();
      } finally {
        quantityTargets.clear(); pendingCartTransform = null; quantityQueueRunning = false;
        setBusy(false); finishQueuedCheckout(succeeded);
        if (succeeded && removedPaidLine && confirmedCart?.items.length === 0 && !pendingAdd) closeCart();
      }
    }
    cartItems.addEventListener('click', event => {
      const removeButton = event.target.closest('[data-remove-key]');
      if (removeButton) return removeLine(removeButton.dataset.removeKey);
      const quantityButton = event.target.closest('[data-quantity-key]');
      if (quantityButton) updateQuantity(quantityButton.dataset.quantityKey, Number(quantityButton.dataset.quantity));
    });

    async function addToCart() {
      if (busy) return;
      const selected = selectedOffer();
      if (!selected || selected.dataset.available !== 'true') return;
      pendingAdd = true;
      pendingCartTransform = cart => pendingAddCart(selected, cart);
      let addSucceeded = false;
      setBusy(true);
      errorNode.hidden = true;
      showPendingItem(selected);
      openCart({ refresh: false });
      let addAttempted = false;
      try {
        const before = await currentCart();
        window.FTBOffer?.checkCart(before);
        window.FTBReassurance?.checkCart(before);
        const includeGift = wantsGift(before);
        showPendingItem(selected, before);
        confirmedAt = 0;
        addAttempted = true;
        const paidItem = { id: Number(selected.dataset.variantId), quantity: 1, properties: paidLineProperties(selected) };
        const giftItem = { id: giftForAdd(before), quantity: 1, properties: { _renly_gift: 'true' } };
        const addItems = items => requestCart(cartEndpoint('add'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items, sections: [cartStateSection], sections_url: rootPath() }) });
        let giftFailed = false;
        let added;
        try {
          added = await addItems(includeGift ? [paidItem, giftItem] : [paidItem]);
        } catch (error) {
          if (!includeGift || !error.status || error.status >= 500) throw error;
          added = await addItems([paidItem]);
          giftFailed = true;
        }
        pendingCartTransform = null;
        const bundled = bundledCart(added);
        const cart = bundled ? await acceptCart(bundled) : await refreshCart();
        if (!cart) { checkoutQueued = false; window.location.assign(`${rootPath()}cart`); return; }
        addSucceeded = !cartEmpty;
        // Analytics never blocks the purchase; clear stale identifiers after rejection.
        const tracking = window.FTBAnalytics;
        if (tracking) {
          const consented = tracking.allowed();
          const distinct = consented ? tracking.distinctId() : '';
          void requestCart(cartEndpoint('update'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: {
              ftb_consent: distinct ? 'true' : '', ftb_distinct_id: distinct || '',
              ftb_market: distinct ? window.FTBStore?.market || '' : '', ftb_qa: window.RenlyQA?'true':''
            } }) }).catch(() => {});
        }
        if (giftFailed && !cart.items.some(giftLine)) {
          root.dataset.giftEnabled = 'false';
          root.querySelector('[data-gift-promo]')?.remove();
          drawerErrorNode.textContent = text('gift_error', 'Produkten lades till, men den kostnadsfria gåvan kunde inte läggas till.');
          drawerErrorNode.hidden = false;
          return;
        }
        if (root.dataset.purchaseMode === 'checkout') checkoutQueued = true;
      } catch (error) {
        pendingCartTransform = null;
        if (confirmedCart) renderCart(confirmedCart);
        errorNode.textContent = error.status ? error.message : addAttempted ? text('add_uncertain', 'Kunde inte bekräfta tillägget. Kontrollera varukorgen innan du försöker igen.') : error.message;
        errorNode.hidden = false;
        drawerErrorNode.textContent = errorNode.textContent;
        drawerErrorNode.hidden = false;
        await refreshCart();
      }
      finally { pendingCartTransform = null; pendingAdd = false; setBusy(false); finishQueuedCheckout(addSucceeded); }
    }
    root.querySelectorAll('[data-add-to-cart]').forEach(button => button.addEventListener('click', addToCart));
    const sticky = root.querySelector('[data-sticky]');
    const primary = root.querySelector('[data-add-to-cart]');
    const footer = root.querySelector('.renly-footer');
    const stickyAction = root.querySelector('[data-sticky-action]');
    const packOptions = root.querySelector('#pack-options');
    if (stickyAction && packOptions) stickyAction.addEventListener('click', event => {
      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      packOptions.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'start' });
    });
    function setStickyVisible(visible) {
      if (!sticky) return;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      sticky.inert = !visible;
    }
    function updateSticky() {
      if (!sticky || !primary) return;
      if (cartLayer.classList.contains('is-open')) return setStickyVisible(false);
      const ctaBottom = primary.getBoundingClientRect().bottom;
      const footerReached = footer && footer.getBoundingClientRect().top <= window.innerHeight - sticky.offsetHeight;
      const alreadyVisible = sticky.classList.contains('is-visible');
      setStickyVisible(!footerReached && (alreadyVisible ? ctaBottom < 16 : ctaBottom < -16));
    }
    if (sticky && primary) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(updateSticky, { threshold: 0 });
        observer.observe(primary);
      }
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }
    setOffer(selectedOffer());
    refreshCart();
  }

  function boot() { document.querySelectorAll('[data-renly-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
